import React, { ReactElement } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

export interface IActions {
  label?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  variant?: 'outlined' | 'text' | 'contained';
  testId?: string;
  iconButton?: ReactElement;
}

interface IDialog {
  isOpen?: boolean;
  title?: string | ReactElement;
  children?: string | ReactElement;
  actions?: IActions[];
  maxWidth?: string;
  description?: string | ReactElement;
  onClose?: () => void;
}

export const CustomDialog: React.FC<IDialog> = ({
  isOpen = true,
  title,
  description,
  children,
  actions,
  maxWidth = '542px',
  onClose,
}) => {
  return (
    <Dialog fullWidth PaperProps={{ sx: { maxWidth: maxWidth } }} open={isOpen} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      {(!!children || !!description) && (
        <DialogContent>
          {!!description && <DialogContentText>{description}</DialogContentText>}
          {children}
        </DialogContent>
      )}
      <DialogActions sx={{ paddingX: 3, paddingY: 2 }}>
        {actions?.map((item, index) => (
          <Button
            key={index}
            data-testid={item.testId}
            variant={item.variant || 'text'}
            disabled={item.disabled}
            onClick={item.onClick}
            sx={{ fontWeight: 600 }}
          >
            {item.iconButton || null}
            {item.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};
